/* eslint-disable */
import { PluginContainerData, Media, Link } from './common';

export interface ImageData {
  /** Styling for the image's container. */
  containerData?: PluginContainerData;
  /** Image file details. */
  image?: Media;
  /** Link details for images that are links. */
  link?: Link;
  /** Sets whether the image expands to full screen when clicked. Defaults to `false`. */
  disableExpand?: boolean;
  /** Image's alternative text. */
  altText?: string;
  /**
   * Deprecated: use Caption node instead.
   *
   * @deprecated
   */
  caption?: string;
  /** Sets whether the image's download button is disabled. Defaults to `false`. */
  disableDownload?: boolean;
  /** Sets whether the image is decorative and does not need an explanation. Defaults to `false`. */
  decorative?: boolean;
  /** Styling for the image. */
  styles?: ImageData_Styles;
}

export interface ImageData_Styles {
  /** Border attributes. */
  border?: ImageData_Styles_Border;
}

export interface ImageData_Styles_Border {
  /** Border width in pixels. */
  width?: number;
  /** Border color as a hexadecimal value. */
  color?: string;
  /** Border radius in pixels. */
  radius?: number;
}

const baseImageData: object = {};

export const ImageData = {
  fromJSON(object: any): ImageData {
    const message = { ...baseImageData } as ImageData;
    message.containerData =
      object.containerData !== undefined && object.containerData !== null
        ? PluginContainerData.fromJSON(object.containerData)
        : undefined;
    message.image =
      object.image !== undefined && object.image !== null
        ? Media.fromJSON(object.image)
        : undefined;
    message.link =
      object.link !== undefined && object.link !== null ? Link.fromJSON(object.link) : undefined;
    message.disableExpand =
      object.disableExpand !== undefined && object.disableExpand !== null
        ? Boolean(object.disableExpand)
        : undefined;
    message.altText =
      object.altText !== undefined && object.altText !== null ? String(object.altText) : undefined;
    message.caption =
      object.caption !== undefined && object.caption !== null ? String(object.caption) : undefined;
    message.disableDownload =
      object.disableDownload !== undefined && object.disableDownload !== null
        ? Boolean(object.disableDownload)
        : undefined;
    message.decorative =
      object.decorative !== undefined && object.decorative !== null
        ? Boolean(object.decorative)
        : undefined;
    message.styles =
      object.styles !== undefined && object.styles !== null
        ? ImageData_Styles.fromJSON(object.styles)
        : undefined;
    return message;
  },

  toJSON(message: ImageData): unknown {
    const obj: any = {};
    message.containerData !== undefined &&
      (obj.containerData = message.containerData
        ? PluginContainerData.toJSON(message.containerData)
        : undefined);
    message.image !== undefined &&
      (obj.image = message.image ? Media.toJSON(message.image) : undefined);
    message.link !== undefined && (obj.link = message.link ? Link.toJSON(message.link) : undefined);
    message.disableExpand !== undefined && (obj.disableExpand = message.disableExpand);
    message.altText !== undefined && (obj.altText = message.altText);
    message.caption !== undefined && (obj.caption = message.caption);
    message.disableDownload !== undefined && (obj.disableDownload = message.disableDownload);
    message.decorative !== undefined && (obj.decorative = message.decorative);
    message.styles !== undefined &&
      (obj.styles = message.styles ? ImageData_Styles.toJSON(message.styles) : undefined);
    return obj;
  },
};

const baseImageData_Styles: object = {};

export const ImageData_Styles = {
  fromJSON(object: any): ImageData_Styles {
    const message = { ...baseImageData_Styles } as ImageData_Styles;
    message.border =
      object.border !== undefined && object.border !== null
        ? ImageData_Styles_Border.fromJSON(object.border)
        : undefined;
    return message;
  },

  toJSON(message: ImageData_Styles): unknown {
    const obj: any = {};
    message.border !== undefined &&
      (obj.border = message.border ? ImageData_Styles_Border.toJSON(message.border) : undefined);
    return obj;
  },
};

const baseImageData_Styles_Border: object = {};

export const ImageData_Styles_Border = {
  fromJSON(object: any): ImageData_Styles_Border {
    const message = { ...baseImageData_Styles_Border } as ImageData_Styles_Border;
    message.width =
      object.width !== undefined && object.width !== null ? Number(object.width) : undefined;
    message.color =
      object.color !== undefined && object.color !== null ? String(object.color) : undefined;
    message.radius =
      object.radius !== undefined && object.radius !== null ? Number(object.radius) : undefined;
    return message;
  },

  toJSON(message: ImageData_Styles_Border): unknown {
    const obj: any = {};
    message.width !== undefined && (obj.width = message.width);
    message.color !== undefined && (obj.color = message.color);
    message.radius !== undefined && (obj.radius = message.radius);
    return obj;
  },
};
